$(function () {

    $('#findSchoolBtn').on('click', function (e) {
        e.preventDefault();
        let selectedSchoolName = $('#selectedSchoolName').val();
        let selectedSchoolType = $('#selectedSchoolType').val();
        let findSchoolList = $('#find-school-list');

        findSchoolList.empty();

        $('.searched-school-list').show();

        if (!selectedSchoolName || !selectedSchoolType) {
            alert('Enter the Inputs')
        } else {
            let formData = new FormData;
            formData.append("typeid", selectedSchoolType);
            formData.append("schName", selectedSchoolName);

            console.log([selectedSchoolType, selectedSchoolName]);
            mainApiAxios.get(`/dashboard/claimSchool?schName=${selectedSchoolName}&typeid=${selectedSchoolType}`).then(res => {

                let schoolFetched = res.data.data;
                console.log(schoolFetched);

                schoolFetched.forEach(schoolListed => {
                    findSchoolList.append(`<div class="card-body d-flex justify-content-between">
                                <div class="col-md-9">
                                    <h5 class="card-title font-weight-bold">${schoolListed.name}</h5>
                                    <p class="card-text">${schoolListed.locality}</p>
                                </div>
                                <div class="col-md-3 ">
                                ${schoolListed.owner ? `<p class="btn-secondary btn float-right">Already Claimed</p>` : `<a href="${APP_URL}/dashboard/register?sch_id=${schoolListed.id}&sch_type=${schoolListed.typeid}" target="_self" class="btn-success btn float-right">Claim</a>`}
                                </div>
                            </div>
                            <hr class="hr"/>`);
                });


                findSchoolList.append(`<div class="card-body">
                    <h5 class="card-title font-weight-bold text-red">Cannot find your School?</h5>
                    <p class="card-text">Fill the form below to create a listing on Edustoke</p>
                    <div class="d-flex row">
                        <div class="row col-md-9">
                             <input type="text" class="form-control col-md-8" placeholder="Enter School Name"
                                   aria-label="School Name" id="selectedSchoolName2">
                                <select id="selectedSchoolType2" class="form-control  col ml-2">
                                <option  value="" selected disabled>Select School Type</option>
                                <option value="1">Day School</option>
                                <option value="2">Early Age / PreSchool</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <button class="btn btn-primary float-right" onclick="addNewSchool()">Add School</button>
                        </div>
                    </div>
                </div>`);
                $("#selectedSchoolType2").val(selectedSchoolType);
                $("#selectedSchoolName2").val(selectedSchoolName);

            }).catch(err => {
                console.log(err);
                findSchoolList.append(`<div class="card-body">
                    <h5 class="card-title font-weight-bold text-red">Cannot find your School?</h5>
                    <p class="card-text">Fill the form below to create a listing on Edustoke</p>
                    <div class="d-flex row">
                        <div class="row col-md-9">
                            <input type="text" class="form-control col-md-8" placeholder="Enter School Name"
                                   aria-label="School Name" id="selectedSchoolName2">
                                <select id="selectedSchoolType2" class="form-control col ml-2">
                                <option  value="" selected disabled>Select School Type</option>
                                <option value="1">Day School</option>
                                <option value="2">Early Age / PreSchool</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <button onclick="addNewSchool()" class="btn btn-primary float-right">Add School</button>
                        </div>
                    </div>
                </div>`);
                $("#selectedSchoolType2").val(selectedSchoolType);
                $("#selectedSchoolName2").val(selectedSchoolName);

            })
        }

    });


});

window.addNewSchool = () => {
    let newTypeId = $("#selectedSchoolType2").val();
    let newschName = $("#selectedSchoolName2").val();

    window.open(`${APP_URL}/dashboard/register?sch_name=${newschName ?? ''}&sch_type=${newTypeId ?? ''}`, "_self")
}
